import { createFileRoute } from "@tanstack/react-router";
import { exportQuoteSearchSchemaValidator } from "../../../features/export-quote/export-quote-search-params";
import { ExportQuotePage } from "../../../pages/export-quote-page/export-quote-page";

export const Route = createFileRoute("/_auth/_project/$projectId/$subProjectId/export-quote")({
  component: ExportQuotePage,
  validateSearch: exportQuoteSearchSchemaValidator,
});
